<template>
  <div class="about">
    <v-header />
    <div class="banner">
      <img src="./image/banner.png" alt="" />
    </div>
    <div class="about-cont">
      <div class="left-bg"></div>
      <div class="right-bg"></div>
      <div class="about-wrap">
        <div class="left">
          <p>{{ $tc('lang.header.About_us') }}</p>
          <ul class="about-us">
            <li @click="toggle('1')">
              <span class="li-span1"></span
              ><span class="li-spanSize">{{
                $tc('lang.AboutUs.Company_Profile')
              }}</span>
            </li>
            <li @click="toggle('2')" v-if="$i18n.locale === 'zh-CN'">
              <span class="li-span2"></span
              ><span class="li-spanSize">{{
                $tc('lang.AboutUs.OUR_VISION')
              }}</span>
            </li>
            <li @click="toggle('3')">
              <span class="li-span3"></span
              ><span class="li-spanSize">{{
                $tc('lang.AboutUs.Contact_us')
              }}</span>
            </li>
          </ul>
          <p>{{ $tc('lang.AboutUs.Contact_Info') }}</p>
          <ul>
            <li><span class="li-span4"></span><span>0571-86375773</span></li>
            <li>
              <span class="li-span5"></span><span>service@minderwork.com</span>
            </li>
            <li>
              <span class="li-span6"></span><span>www.minderworks.com</span>
            </li>
          </ul>
        </div>
        <div class="right">
          <div class="item" v-if="selected == '1'">
            <p>{{ $tc('lang.AboutUs.Company_Profile') }}</p>
            <div class="img-box"><img src="./image/bg1.png" alt="" /></div>
            <div>
              {{ $tc('lang.AboutUs.What_can_text') }}
            </div>
          </div>
          <div class="item" v-if="selected == '2' && $i18n.locale === 'zh-CN'">
            <p>{{ $tc('lang.AboutUs.OUR_VISION') }}</p>
            <div class="img-box"><img src="./image/bg1.png" alt="" /></div>
            <div>
              创新融合
              <br />
              不断进取
              <br />
              诚信担当
              <br />
              用专业的技术，赋能全球供应体系
            </div>
          </div>
          <div class="item" v-if="selected == '3'">
            <p>{{ $tc('lang.AboutUs.Contact_us') }}</p>
            <div class="img-box"><img src="./image/bg1.png" alt="" /></div>
            <div>
              官方网站： www.minderworks.com
              <br />
              商务咨询：service@minderwork.com
              <br />
              公司地址：{{ $tc('lang.header.footer_address') }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-footer />
  </div>
</template>
<script>
import Header from '../home/components/header.vue';
import Footer from '../home/components/footer.vue';
export default {
  name: 'About',
  data() {
    return {
      selected: '1',
    };
  },
  methods: {
    toggle(key) {
      this.selected = key;
    },
  },
  components: {
    'v-header': Header,
    'v-footer': Footer,
  },
};
</script>
<style lang="less">
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.about-cont {
  position: relative;

  .left-bg {
    width: 27vw;
    height: 54vw;
    background: url(image/baseMap1349.png) no-repeat;
    background-size: 100% 100%;
    top: 5vh;
    left: 0;
    position: absolute;
    z-index: -10;
  }
  .right-bg {
    width: 3vw;
    height: 6vw;
    background: url(image/right-bg.png) no-repeat;
    background-size: 100% 100%;
    bottom: 5vh;
    right: 0;
    position: absolute;
    z-index: -10;
  }
  .about-wrap {
    width: 82vw;
    margin: 3vh auto;
    overflow: hidden;
    .left {
      height: 72vh;
      float: left;
      width: 18vw;
      margin: 1vw;
      padding: 2vh 1vw;
      box-sizing: border-box;
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
      background-color: #fff;
      p {
        font-size: 16px;
        color: #000;
        text-align: left;
        padding: 0 0 3vh 2vw;
        font-weight: bold;
        border-bottom: 1px solid #f6f6f6;
      }
      ul {
        padding-left: 0;
        li {
          list-style: none;
          line-height: 7vh;
          text-align: left;
          cursor: pointer;
          padding-left: 2vw;
          span:nth-child(1) {
            width: 2.5vh;
            height: 2.5vh;
            display: inline-block;
            margin-right: 1vw;
            position: relative;
          }
          .li-span1 {
            background: url(image/icon1.png) no-repeat;
            background-size: 100% 100%;
            top: 0.2vh;
          }
          .li-spanSize {
            font-size: 18px;
          }
          .li-span2 {
            background: url(image/icon2.png) no-repeat;
            background-size: 100% 100%;
            top: 0.3vh;
          }
          .li-span3 {
            background: url(image/icon3.png) no-repeat;
            background-size: 100% 100%;
            top: 0.4vh;
          }
          .li-span4 {
            background: url(image/icon-tel.png) no-repeat;
            background-size: 100% 100%;
            top: 0.7vh;
          }
          .li-span5 {
            background: url(image/icon-email.png) no-repeat;
            background-size: 100% 100%;
            top: 0.5vh;
          }
          .li-span6 {
            background: url(image/icon-net.png) no-repeat;
            background-size: 100% 100%;
            top: 0.7vh;
          }
        }
      }
      .about-us {
        margin-bottom: 8vh;
      }
    }
    .right {
      height: 72vh;
      /*overflow: auto;*/
      float: left;
      width: 60vw;
      margin: 1vw;
      padding: 3vh 4vw;
      box-sizing: border-box;
      border: 1px solid #f6f6f6;
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
      .item {
        p {
          text-align: left;
          font-size: 16px;
          font-weight: bold;
          color: #000;
        }
        .img-box {
          width: 52vw;
          margin-bottom: 3vh;
          img {
            width: 100%;
          }
        }
        div {
          text-align: left;
          line-height: 4vh;
        }
      }
    }
  }
}
</style>
